<app-service-container [loadingMessage]="undefined" [service]="service">
    <div class="d-flex gap-5">
        <app-tag-field [tag]="tag" *ngFor="let tag of (service.result$ | async)"></app-tag-field>
        <div matTooltip="Modifier les étiquettes"
                (click)="open()"
                style="height: 15px; width: 15px; border-radius: 50%; border: 1px dashed gray; cursor: pointer;">
        </div>
    </div>

</app-service-container>